<template>
  <DefaultPageContainer
    :cnc-ads-page="cncAdsPage"
    :breadcrumb-text="getHeadingMessage()"
    error-page
  >
    <section
      class="section relative section--error"
      :class="{'hidden': getErrorCode() < 500 }"
    >
      <div class="w-8/12 max-w-64 flex justify-end mx-auto">
<!--        <img class="w-9/12" src="/img/poggers/error-page/error-page_socket.svg" alt="">-->
        <div class="w-9/12 h-56 error__socket"></div>
      </div>
      <div class="sm:mx-auto sm:text-center max-w-64">
        <h3 class="text-[32px] leading-8 font-bold" v-html="getHeadingMessage()" />
        <span class="error__subheading text-sm pt-2" v-html="getSubheadingMessage()" />
      </div>
      <div class="absolute -bottom-4 -mb-20 -right-20 xs:right-0">
        <img class="w-full" src="/img/poggers/error-page/error-page_cord.svg" alt="">
      </div>
    </section>
    <section
      class="section"
      :class="{'hidden': getErrorCode() >= 500 }"
    >
      <div class="error">
        <span class="error__code text-5xl font-semibold">
          {{ getErrorCode() }}
        </span>
        <div class="error__line">
          <svg width="272" height="80" viewBox="0 0 272 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M29.4129 7.13679C22.1904 3.47584 13.3789 1.69386 1.90633 3.75896C1.36278 3.8568 0.842832 3.49548 0.744992 2.95193C0.647152 2.40838 1.00847 1.88843 1.55202 1.79059C13.4408 -0.349413 22.6954 1.48956 30.3171 5.35287C37.9083 9.20068 43.8202 15.0284 49.0717 20.7485C50.1527 21.9259 51.2026 23.0947 52.2318 24.2405C56.2503 28.7139 59.9522 32.8351 63.947 35.7373C68.8776 39.3193 74.1426 40.9534 80.8635 38.8853C94.9893 34.539 102.669 32.3134 108.219 31.8867C113.91 31.4491 117.384 32.9012 123.018 35.6104C123.516 35.8497 123.726 36.4472 123.486 36.945C123.247 37.4427 122.65 37.6522 122.152 37.4129C116.572 34.73 113.505 33.4861 108.372 33.8808C103.098 34.2864 95.6715 36.4216 81.4517 40.7969C74.0002 43.0897 68.0907 41.2197 62.7715 37.3553C58.5881 34.3161 54.7005 29.986 50.6661 25.4924C49.6551 24.3663 48.6349 23.23 47.5984 22.1011C42.3763 16.413 36.6659 10.8132 29.4129 7.13679ZM203.741 57.03C204.098 56.6082 204.729 56.5554 205.151 56.912C209.861 60.8945 214.207 60.2757 219.056 59.5853C219.263 59.5558 219.471 59.5262 219.68 59.4968C222.206 59.1414 224.898 58.8217 227.694 59.329C230.523 59.8425 233.395 61.1879 236.348 64.0408C239.052 66.6528 241.372 67.76 243.579 68.2463C245.392 68.6458 247.139 68.6373 249.1 68.6277C249.598 68.6253 250.109 68.6228 250.639 68.6269C253.219 68.6468 256.071 68.8361 259.405 70.0874C262.733 71.3361 266.477 73.6175 270.909 77.7324C271.313 78.1082 271.337 78.741 270.961 79.1457C270.585 79.5504 269.952 79.5738 269.548 79.198C265.258 75.2144 261.73 73.0961 258.703 71.9599C255.682 70.8265 253.097 70.6459 250.624 70.6268C250.154 70.6232 249.683 70.6259 249.209 70.6286C247.224 70.64 245.2 70.6516 243.148 70.1995C240.54 69.6248 237.897 68.3181 234.958 65.4792L235.653 64.76L234.958 65.4792C232.269 62.8813 229.75 61.7349 227.336 61.2969C224.889 60.8528 222.484 61.122 219.958 61.4773C219.719 61.5109 219.48 61.5453 219.239 61.5798C214.437 62.2688 209.267 63.0106 203.86 58.4393C203.438 58.0827 203.385 57.4518 203.741 57.03Z"/>
          </svg>
        </div>
      </div>
      <div class="flex flex-col items-center text-center mt-4 mb-6">
        <h3 class="text-[32px] font-bold" v-html="getHeadingMessage()" />
        <span class="error__subheading text-sm pt-2" v-html="getSubheadingMessage()" />
        <button
          class="btn py-3 px-6 mt-6"
          @click="handleError"
        >
          {{ $t('errors.go_to_homepage') }}
        </button>
      </div>

      <DefaultTwoColumnsContent
        v-if="getErrorCode() < 500 && articleStore.getFilteredArticlesCount()"
        right-container-class="section__right-col--mobile-hide"
      >
        <template #left>
          <!-- Recommended articles -->
          <div class="section__articles-container">
            <div>
              <h3 class="h4">
                {{ $t('articles.related-error-page_articles_title') }}
              </h3>
            </div>

            <!-- Article -->
            <DefaultArticlesArticleCard
              v-for="(article, index) in articleStore.getOnlyFilteredArticles(0, pageArticlesCount)"
              :article="article"
              :key="`article_${article.id}`"
              :data-index="index"
            />

          </div>
        </template>
        <template #right>
          <!-- CNC Ads - right sticky container -->
          <div class="advertisement-right-col h-full">
            <div class="sticky-sidebar-ad-wrapper">
              <DefaultAdsCncWrapper
                :position="UniFeAdsPosition.COLUMN_STICKY"
                :page="cncAdsPage"
              />
            </div>
          </div>
        </template>
      </DefaultTwoColumnsContent>
    </section>

  </DefaultPageContainer>
</template>

<script setup lang="ts">
import type {NuxtError} from '#app'
import { useI18n } from "vue-i18n"
import {useArticlesStore} from "~/stores/useArticlesStore"
import {ArticleStoreType} from "~/libs/constants/ArticleStoreType"
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import {UniFeAdsPosition} from "~/libs/constants/UniFeAdsPosition"

const {t} = useI18n()
const logger = useFrontendLogger()
const config = useRuntimeConfig()

const pageArticlesCount = Number(config.public.errorPageArticlesCount || 5)

const props = defineProps({
  error: Object as () => NuxtError
})

const cncAdsPage = CncAdsPage.HOMEPAGE

const getErrorCode = () => {
  return props.error?.statusCode || 500
}

const getHeaderTitle = () => {
  switch (getErrorCode()) {
    case 404:
    case 410:
      return t('errors.error_404_header_title')
    default:
      if (getErrorCode()) {
        return `${t('errors.error')} ${getErrorCode()}`
      }
      return t('errors.error_500_heading')
  }

}

const getHeadingMessage = () => {
  switch (getErrorCode()) {
    case 404:
    case 410:
      return t('errors.error_404_heading')
    default:
      return t('errors.error_500_heading')
  }
}

const getSubheadingMessage = () => {
  switch (getErrorCode()) {
    case 404:
    case 410:
      return t('errors.error_404_subheading')
    default:
      return t('errors.error_500_subheading')
  }
}

const handleError = () => clearError({redirect: "/"})

const articleStore = useArticlesStore(ArticleStoreType.HOMEPAGE)

// load articles for error code < 500
if (getErrorCode() < 500 && import.meta.client) {
  articleStore.setLimit(pageArticlesCount)
  articleStore.fetchArticles()
}

const logError = () => {
  switch (getErrorCode()) {
    case 404:
    case 410:
      logger.error(`Nuxt error page: Page not found (code: ${getErrorCode()})`, props.error)
      return
    default:
      logger.error(`Nuxt error page: Server error (code: ${getErrorCode()})`, props.error)
      return
  }
}

logError()
</script>

<style lang="postcss">

  .fit-text {
    @apply text-[50vw] lg:text-[560px] font-bold text-black text-center;
    white-space: nowrap;
    opacity: 2%;
    line-height: 1;
  }

</style>
